import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";

const CoachDashboard = lazy(() => import("@/pages/coach/CoachDashboard"));
const CoachAnalytics = lazy(() => import("@/pages/coach/CoachAnalytics"));
const CoachSettings = lazy(() => import("@/pages/coach/CoachSettings"));
const CoachLessonsManager = lazy(() => import("@/pages/coach/CoachLessonsManager"));
const CoachAgenda = lazy(() => import("@/pages/coach/CoachAgenda"));
const CoachStudents = lazy(() => import("@/pages/coach/CoachStudents"));
const CoachChatPage = lazy(() => import("@/pages/coach/CoachChatPage"));
const CoachBookings = lazy(() => import("@/pages/coach/CoachBookings"));
const CoachSubscription = lazy(() => import("@/pages/coach/CoachSubscription"));

export const coachRoutes = (
  <>
    <Route
      path="/coach"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachDashboard />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/lessons"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachLessonsManager />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/agenda"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachAgenda />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/students"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachStudents />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/chat"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachChatPage />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/analytics"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachAnalytics />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/bookings"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachBookings />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/subscription"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachSubscription />
        </ProtectedRoute>
      }
    />
    <Route
      path="/coach/settings"
      element={
        <ProtectedRoute requiredRoles={["coach"]}>
          <CoachSettings />
        </ProtectedRoute>
      }
    />
  </>
);
